/******/ (() => { // webpackBootstrap
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.cacheDOMElements();
      this.bindEventHandlers();
    }

    connectedCallback() {
      this.cacheDOMElements();
      if (!this.sectionId || !this.wrapper) return;
      this.addEventListeners();
      this.debouncedRenderRecentlyViewedProducts();
    }

    cacheDOMElements() {
      this.sectionId = this.getAttribute('data-wetheme-section-id');
      this.isPreviewMode = this.getAttribute('data-is-preview-mode') == 'true';
      this.wrapper = this.closest('data-recently-viewed-wrapper');
    }

    bindEventHandlers() {
      this.debouncedRenderRecentlyViewedProductsBound = this.debouncedRenderRecentlyViewedProducts.bind(this);
    }

    addEventListeners() {
      if (window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.debouncedRenderRecentlyViewedProductsBound);
      }
    }

    debouncedRenderRecentlyViewedProducts() {
      if (!this.sectionId || !this.wrapper) return;
      if (this.renderTimeout) clearTimeout(this.renderTimeout);
      if (this.abortController) this.abortController.abort();

      const delay = window.Shopify.designMode ? 800 : 100;
      this.renderTimeout = setTimeout(() => this.renderRecentlyViewedProducts(), delay);
    }

    async renderRecentlyViewedProducts() {
      if (!this.sectionId || !this.wrapper) return;

      try {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        const recentlyViewedProducts = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
        if (!recentlyViewedProducts.length && !this.isPreviewMode) {
          this.wrapper.style.display = 'none';
          return;
        }

        const items = new Set(recentlyViewedProducts);
        if (this.hasAttribute('exclude-id')) {
          items.delete(parseInt(this.getAttribute('exclude-id')));
        }

        if (!items.size && !this.isPreviewMode) {
          this.wrapper.style.display = 'none';
          return;
        }

        const queryString = Array.from(items.values(), (item) => `id:${item}`)
          .slice(0, parseInt(this.getAttribute('data-products-to-show')))
          .join(' OR ');

        let url = `${window.Shopify.routes.root}search?type=product&q=${queryString}&section_id=${this.sectionId}`;
        if (window.Shopify.designMode) url += `&t=${Date.now()}`;

        const response = await fetch(url, { signal: this.abortController.signal });
        const responseText = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;
        const recentlyViewedProductsElement = tempDiv.querySelector('recently-viewed-products');

        if (recentlyViewedProductsElement && recentlyViewedProductsElement.childElementCount > 0) {
          this.replaceChildren(...recentlyViewedProductsElement.childNodes);
          window.eventBus.emit('recentlyViewed:updated');
        } else if (!this.isPreviewMode) {
          this.wrapper.style.display = 'none';
        }
      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error('Error fetching recently viewed products:', e);
          if (!this.isPreviewMode && this.wrapper) this.wrapper.style.display = 'none';
        }
      }
    }

    disconnectedCallback() {
      if (this.renderTimeout) clearTimeout(this.renderTimeout);
      if (this.abortController) this.abortController.abort();
      if (window.Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.debouncedRenderRecentlyViewedProductsBound);
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}

/******/ })()
;
